module.exports = __webpack_public_path__ + "img/MpeV3B-2.553e2395.jpg";